import { FormEvent, JSX, useContext, useEffect, useState } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import { RegistryWidgetsType, UiSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import { ReactFlowInstance, useReactFlow } from "@xyflow/react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
    formSchema,
    nodeDescription,
    processNodeDelete,
    processNodeFormSubmit
} from "./functions/workflow-scraper-node-configuration";
import { PromptTemplateFormWidget } from "./components/PromptTemplateFormWidget";
import { LLMModelWidget } from "./components/LLMModelWidget";
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import { DefaultFormDialog } from "./components/DefaultFormDialog";
import { ModelSchemaWidget } from "./components/ModelSchemaWidget";
import {
    Button
} from '@mui/material';

export const WorkflowScraperNodeConfiguration: () => JSX.Element = (): JSX.Element => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();
    const [formData, setFormData] = useState<any>();

    function handleCloseDialog(): void {
        context.toggleScraperNodeModalShow(false);
    }

    const handleFormSubmit: (data: IChangeEvent, event: FormEvent<any>) => void = (data: IChangeEvent, event: FormEvent<any>) : void => {
        // console.log(data.formData);
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        // handleCloseDialog();
    }

    function deleteNode(): void {
        processNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }

    function duplicateNode(): void {
        if (formData !== undefined && formData.node_id !== undefined) {
            const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            let result: string = "";
            for (let i: number = 0; i < 12; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            const currentNode: any = reactFlowInstance.getNode(formData.node_id);
            let duplicateNode: any = structuredClone(currentNode);
            duplicateNode.id = result;
            duplicateNode.position.x = duplicateNode.position.x + 200 || 300
            duplicateNode.position.y = duplicateNode.position.x + 200 || 300
            let nodes = reactFlowInstance.getNodes();
            let newNodes: any = [duplicateNode];
            for (const node of nodes) {
                newNodes.push(node);
            }
            context.updateLayoutNodes(newNodes);
        }

    }

    useEffect( (): void => {
        if (context.activeEditScraperNode !== undefined && context.activeEditScraperNode.data !== undefined) {
            setFormData(context.activeEditScraperNode.data);
        }
    }, [context] );

    const uiSchema: UiSchema = {
        'data_input': {
            'ui:widget': 'NodeDataManagementWidget',
            'ui:options': {
                'classNames': 'data-management'
            }
        },
        'data_management': {
            'ui:widget': 'NodeDataManagementWidget',
            'ui:options': {
                'classNames': 'data-management'
            }
        },
        // 'exclude_product_page_stock_words': {
        //     'ui:widget': 'textarea',
        // },
        // 'exclude_product_page_cart_words': {
        //     'ui:widget': 'textarea',
        // },
        // 'exclude_product_page_price_regex': {
        //     'ui:widget': 'textarea',
        // },
        search_points: {
            "items": {
                "keywords": {
                    'ui:widget': 'textarea',
                },
                "entity_keywords": {
                    'ui:widget': 'textarea',
                    "ui:options": {
                        rows: 5 // optional, controls height
                    }
                },
                "regex_value": {
                    'ui:widget': 'textarea',
                },
            }
        }
    }

    const widgets: RegistryWidgetsType = {
        PromptTemplateFormWidget: PromptTemplateFormWidget,
        LLMModelWidget: LLMModelWidget,
        NodeDataManagementWidget: NodeDataStoreSelectWidget,
        ModelSchemaWidget: ModelSchemaWidget
    }

    return (
        <DefaultFormDialog
            open={ context.showScraperModal }
            title={ "Web Scraper Node" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }


        >
            <span style={ { paddingLeft: '15px', fontWeight: 'bold' } }>{ "Node ID: " + context?.activeEditScraperNode?.id }</span>
            <Form
                validator={ validator }
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                widgets={ widgets }
                id="workflow-scraper-node-configure"
                formData={ formData }
                formContext={ formData }
                onChange={ ({ formData }: IChangeEvent): void => setFormData(formData) }
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    { (formData?.node_id !== undefined ) &&
                        <Button
                            onClick={ duplicateNode }
                            variant="contained"
                            color="warning"
                            type="button">
                            <ContentCopyIcon />
                            <span>{ "Duplicate" }</span>
                        </Button>
                    }
                    { (context.activeEditScraperNode ) &&
                        <Button
                            variant="contained"
                            color="error"
                            onClick={ deleteNode }
                            type="button">
                            <DeleteIcon />
                            <span>{ "Delete" }</span>
                        </Button>
                    }

                </div>
            </Form>
        </DefaultFormDialog>
    );
}